<template>
  <b-modal
    id="review-fast-invoice-modal"
    ref="review-fast-invoice-modal"
    size="xl"
    hide-footer
    no-close-on-backdrop
    :title="modalTitle"
    @hidden="onHidden"
  >
    <b-overlay
      :show="loading"
      variant="white"
      opacity="0.85"
      rounded="sm"
    >
      <div v-if="rows.length">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap mb-3"
        >
          <div>
            <span class="mr-3">Tổng: <strong>{{ rows.length }}</strong></span>
            <span class="mr-3 text-success"
              >Hợp lệ: <strong>{{ validRows.length }}</strong></span
            >
            <span class="text-danger"
              >Không hợp lệ: <strong>{{ fatalRows.length }}</strong></span
            >
          </div>
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-2 font-weight-bold small">
              Nguồn tra cứu MST:
            </label>
            <b-form-radio-group
              v-model="fromPartner"
              :options="fromPartnerOptions"
              :disabled="submitting"
              size="sm"
              name="batch-tax-source"
            />
          </div>
          <div v-if="!isCreateMode" class="d-flex align-items-center">
            <label class="mb-0 mr-2 font-weight-bold small">Chế độ:</label>
            <b-form-radio-group
              v-model="editMode"
              :options="editModeOptions"
              :disabled="submitting"
              size="sm"
              name="publish-edit-mode"
              buttons
              button-variant="outline-primary"
            />
          </div>
          <div v-if="hasResults">
            <span class="mr-3 text-success"
              >Thành công: <strong>{{ successCount }}</strong></span
            >
            <span class="text-danger"
              >Thất bại: <strong>{{ failedCount }}</strong></span
            >
          </div>
        </div>

        <div class="table-responsive">
          <table
            class="table table-bordered table-sm review-fast-table"
          >
            <thead>
              <tr>
                <th class="text-center" style="min-width: 80px">Mã HĐ</th>
                <th class="text-center" style="min-width: 90px">B2B/B2C</th>
                <template v-if="isCreateMode">
                  <th style="min-width: 200px">Tên khách hàng</th>
                  <th style="min-width: 190px">MST</th>
                  <th style="min-width: 120px">SĐT</th>
                  <th style="min-width: 200px">Địa chỉ</th>
                  <th style="min-width: 190px">Email</th>
                </template>
                <template v-else>
                  <th style="min-width: 240px">Khách hàng</th>
                  <th style="min-width: 200px">Địa chỉ</th>
                  <th style="min-width: 190px">Email</th>
                </template>
                <th class="text-right" style="min-width: 120px">Thành tiền</th>
                <th class="text-right" style="min-width: 110px">Chiết khấu</th>
                <th class="text-center" style="min-width: 80px">VAT(%)</th>
                <th style="min-width: 160px">Trạng thái</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="row in rows">
                <tr
                  :key="row.billNumber"
                  :class="{
                    'review-fast-error-row':
                      row.isFatal || row.resultStatus === RESULT_STATUS.FAILED,
                  }"
                >
                <td class="text-center align-middle">
                  <b-button
                    v-if="row.details && row.details.length"
                    variant="link"
                    size="sm"
                    class="p-0 mb-1 review-fast-expand-btn"
                    :title="
                      isExpanded(row.billNumber)
                        ? 'Thu gọn sản phẩm'
                        : 'Xem sản phẩm'
                    "
                    @click="toggleExpand(row.billNumber)"
                  >
                    <i
                      class="mr-1"
                      :class="
                        isExpanded(row.billNumber)
                          ? 'fas fa-chevron-down'
                          : 'fas fa-chevron-right'
                      "
                    ></i>{{ row.details.length }} SP
                  </b-button>
                  <div class="font-weight-bold">{{ row.billNumber }}</div>
                  <span
                    v-if="billTypeBadge"
                    class="label label-inline label-sm mt-1"
                    :class="billTypeBadge.class"
                    >{{ billTypeBadge.text }}</span
                  >
                </td>
                <td class="text-center align-middle">
                  <b-form-select
                    v-if="isCreateMode || editMode"
                    v-model="row.billVatType"
                    size="sm"
                    :disabled="!isEditable(row)"
                    :options="vatTypeOptions"
                    title="Chọn loại hóa đơn: B2B (công ty) để nhập & tra cứu MST"
                  />
                  <span
                    v-else
                    class="label label-inline label-sm"
                    :class="
                      row.billVatType === VAT_TYPE.COMPANY
                        ? 'label-light-primary'
                        : 'label-light-info'
                    "
                    >{{
                      row.billVatType === VAT_TYPE.COMPANY ? 'B2B' : 'B2C'
                    }}</span
                  >
                </td>
                <!-- TẠO hóa đơn đỏ: cho sửa. PHÁT HÀNH FAST: chỉ đọc dạng text -->
                <template v-if="isCreateMode">
                  <td>
                    <b-form-input
                      size="sm"
                      v-model="row.form.billVatName"
                      :disabled="!isEditable(row)"
                      placeholder="Tên khách hàng"
                    />
                    <div
                      v-if="isEditable(row) && suggestionFor(row, 'billVatName')"
                      class="small text-warning mt-1 review-fast-suggest"
                    >
                      <i class="fas fa-lightbulb mr-1"></i>Đề xuất:
                      <strong>{{ suggestionFor(row, 'billVatName').to }}</strong>
                      <b-button
                        variant="primary"
                        size="sm"
                        class="ml-2 py-0 px-2 review-fast-apply"
                        @click="
                          applySuggestion(row, suggestionFor(row, 'billVatName'))
                        "
                        >Áp dụng</b-button
                      >
                    </div>
                  </td>
                  <td>
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="row.form.taxCode"
                        :disabled="!isEditable(row)"
                        :placeholder="
                          row.billVatType === VAT_TYPE.COMPANY
                            ? 'Nhập MST'
                            : 'MST'
                        "
                        @input="onTaxCodeInput(row, $event)"
                      />
                      <b-input-group-append
                        v-if="row.billVatType === VAT_TYPE.COMPANY"
                      >
                        <b-button
                          variant="light-primary"
                          :disabled="!isEditable(row)"
                          title="Tra cứu & điền thông tin theo MST"
                          @click="lookupTaxCode(row)"
                        >
                          <i class="flaticon2-search p-0"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                    <div
                      v-for="(w, wi) in warningsFor(row, 'taxCode')"
                      :key="`w-tax-${row.billNumber}-${wi}`"
                      class="small text-warning mt-1"
                    >
                      <i class="fas fa-exclamation-triangle mr-1"></i>{{
                        w.message
                      }}
                    </div>
                  </td>
                  <td>
                    <b-form-input
                      size="sm"
                      v-model="row.form.phone"
                      :disabled="!isEditable(row)"
                      placeholder="SĐT"
                    />
                  </td>
                  <td>
                    <b-form-input
                      size="sm"
                      v-model="row.form.billVatAddress"
                      :disabled="!isEditable(row)"
                    />
                    <div
                      v-for="(w, wi) in warningsFor(row, 'billVatAddress')"
                      :key="`w-addr-${row.billNumber}-${wi}`"
                      class="small text-warning mt-1"
                    >
                      <i class="fas fa-exclamation-triangle mr-1"></i>{{
                        w.message
                      }}
                    </div>
                  </td>
                  <td>
                    <b-form-input
                      size="sm"
                      v-model="row.form.email"
                      :disabled="!isEditable(row)"
                    />
                  </td>
                </template>
                <template v-else>
                  <td class="align-middle">
                    <template v-if="editMode">
                      <b-form-input
                        size="sm"
                        class="mb-1"
                        v-model="row.form.billVatName"
                        :disabled="!isEditable(row)"
                        placeholder="Tên khách hàng"
                      />
                      <b-input-group size="sm" class="mb-1">
                        <b-form-input
                          v-model="row.form.taxCode"
                          :disabled="!isEditable(row)"
                          :placeholder="
                            row.billVatType === VAT_TYPE.COMPANY
                              ? 'Nhập MST'
                              : 'MST'
                          "
                          @input="onTaxCodeInput(row, $event)"
                        />
                        <b-input-group-append
                          v-if="row.billVatType === VAT_TYPE.COMPANY"
                        >
                          <b-button
                            variant="light-primary"
                            :disabled="!isEditable(row)"
                            title="Tra cứu & điền thông tin theo MST"
                            @click="lookupTaxCode(row)"
                          >
                            <i class="flaticon2-search p-0"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                      <b-form-input
                        size="sm"
                        v-model="row.form.phone"
                        :disabled="!isEditable(row)"
                        placeholder="SĐT"
                      />
                    </template>
                    <template v-else>
                      <div class="font-weight-bold">
                        {{ row.form.billVatName || '-' }}
                      </div>
                      <div
                        v-if="row.form.taxCode"
                        class="small text-muted"
                      >
                        MST: {{ row.form.taxCode }}
                      </div>
                      <div
                        v-if="row.form.phone"
                        class="small text-muted"
                      >
                        SĐT: {{ row.form.phone }}
                      </div>
                    </template>
                  </td>
                  <td class="align-middle">
                    <b-form-input
                      v-if="editMode"
                      size="sm"
                      v-model="row.form.billVatAddress"
                      :disabled="!isEditable(row)"
                    />
                    <template v-else>{{ row.form.billVatAddress || '-' }}</template>
                  </td>
                  <td class="align-middle">
                    <b-form-input
                      v-if="editMode"
                      size="sm"
                      v-model="row.form.email"
                      :disabled="!isEditable(row)"
                    />
                    <template v-else>{{ row.form.email || '-' }}</template>
                  </td>
                </template>
                <td class="text-right align-middle">
                  {{ formatMoney(rowTotalAmount(row)) }}
                </td>
                <td class="text-right align-middle">
                  {{ formatMoney(rowDiscountAmount(row)) }}
                </td>
                <td class="text-center align-middle">
                  {{ rowVatRates(row) }}
                </td>
                <td class="align-middle">
                  <template v-if="row.resultStatus">
                    <div
                      v-if="row.resultStatus === RESULT_STATUS.SUCCESS"
                      class="text-success font-weight-bold"
                    >
                      <i class="fas fa-check-circle mr-1"></i>{{
                        successRowLabel
                      }}
                      <div
                        v-if="isCreateMode && row.billVatId"
                        class="small"
                      >
                        Mã hóa đơn đỏ: {{ row.billVatId }}
                      </div>
                      <div
                        v-else-if="!isCreateMode && row.fastInvoiceNo"
                        class="small"
                      >
                        Số HĐ FAST: {{ row.fastInvoiceNo }}
                      </div>
                    </div>
                    <div v-else class="text-danger font-weight-bold">
                      <i class="fas fa-times-circle mr-1"></i>Thất bại
                      <div v-if="row.error" class="small font-weight-normal">
                        {{ row.error }}
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div v-if="row.errors.length">
                      <div
                        v-for="(err, ei) in row.errors"
                        :key="`e-${row.billNumber}-${ei}`"
                        class="text-danger small"
                      >
                        <i class="fas fa-exclamation-circle mr-1"></i>{{
                          err.message
                        }}
                      </div>
                    </div>
                    <div v-else class="text-success small font-weight-bold">
                      <i class="fas fa-check-circle mr-1"></i>Hợp lệ
                    </div>
                    <div v-if="row.warnings.length" class="mt-1">
                      <div
                        v-for="(w, wi) in row.warnings"
                        :key="`w-${row.billNumber}-${wi}`"
                        class="text-warning small"
                      >
                        <i class="fas fa-exclamation-triangle mr-1"></i>{{
                          w.message
                        }}
                      </div>
                    </div>
                  </template>
                </td>
                </tr>
                <tr
                  v-if="isExpanded(row.billNumber)"
                  :key="`detail-${row.billNumber}`"
                  class="review-fast-detail-row"
                >
                  <td :colspan="detailColspan" class="p-0">
                    <div class="p-3">
                      <div class="font-weight-bold small mb-2 text-dark-75">
                        Sản phẩm của hóa đơn #{{ row.billNumber }}
                      </div>
                      <table
                        class="table table-bordered table-sm mb-0 review-fast-detail-table"
                      >
                        <thead>
                          <tr>
                            <th
                              v-if="isCreateMode"
                              v-b-tooltip.hover
                              class="text-center"
                              style="min-width: 60px"
                              title="Tích = xuất dòng này lên hóa đơn VAT; bỏ tích = không xuất dòng đó"
                            >
                              Xuất
                            </th>
                            <th class="text-center" style="min-width: 48px">STT</th>
                            <th style="min-width: 120px">Mã SP</th>
                            <th style="min-width: 240px">Tên sản phẩm</th>
                            <th class="text-center" style="min-width: 60px">SL</th>
                            <th class="text-center" style="min-width: 100px">
                              Thuế suất
                            </th>
                            <th class="text-right" style="min-width: 110px">Giá</th>
                            <th class="text-right" style="min-width: 120px">
                              Chiết khấu
                            </th>
                            <th class="text-right" style="min-width: 120px">
                              Thành tiền
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(d, di) in row.details"
                            :key="`d-${row.billNumber}-${di}`"
                            :class="{ 'text-muted': isCreateMode && !d.include }"
                          >
                            <td
                              v-if="isCreateMode"
                              v-b-tooltip.hover
                              class="text-center"
                              :title="
                                d.include
                                  ? 'Dòng này SẼ được xuất lên hóa đơn VAT — bỏ tích để loại khỏi hóa đơn'
                                  : 'Dòng này KHÔNG xuất lên hóa đơn VAT — tích để thêm vào hóa đơn'
                              "
                            >
                              <b-form-checkbox
                                v-model="d.include"
                                :disabled="!isEditable(row)"
                                class="d-inline-block"
                              />
                            </td>
                            <td class="text-center">{{ di + 1 }}</td>
                            <td>{{ d.productCode || '-' }}</td>
                            <td>
                              {{ d.productName || '-' }}
                              <span
                                v-if="d.isZeroValue"
                                class="label label-inline label-sm label-light-warning ml-1"
                                >Quà tặng 0đ</span
                              >
                            </td>
                            <td class="text-center">{{ d.quantity }}</td>
                            <td class="text-center">{{ detailVatLabel(d) }}</td>
                            <td class="text-right">
                              {{ formatMoney(d.productPrice) }}
                            </td>
                            <td class="text-right">
                              {{ formatMoney(detailDiscount(d)) }}
                            </td>
                            <td class="text-right">
                              {{ formatMoney(d.totalAmount) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else-if="!loading" class="text-center text-muted py-5">
        Không có dữ liệu để hiển thị.
      </div>

      <div class="d-flex justify-content-end mt-3">
        <b-button
          v-if="pendingRows.length > 0"
          variant="primary"
          size="sm"
          class="font-weight-bolder mr-2"
          :disabled="!canSubmit"
          @click="onSubmitBatch"
        >
          <b-spinner v-if="submitting" small class="mr-1" />
          {{ hasResults ? 'Thử lại' : confirmLabel }} ({{ pendingRows.length }})
        </b-button>
        <b-button
          v-if="isCreateMode && successCount > 0"
          variant="success"
          size="sm"
          class="font-weight-bolder mr-2"
          @click="goToVatInvoiceList"
        >
          <i class="fas fa-external-link-alt mr-1"></i>Xem danh sách hóa đơn đỏ
        </b-button>
        <b-button
          variant="secondary"
          size="sm"
          class="font-weight-bolder"
          @click="hide"
        >
          {{ hasResults ? 'Thoát' : 'Đóng' }}
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import debounce from 'debounce';

import ApiService from '@/core/services/api.service';
import { TIME_TRIGGER } from '@/utils/constants';
import {
  xoa_dau,
  makeToastSuccess,
  makeToastFaile,
  makeToastWarning,
  convertPrice,
} from '@/utils/common';
import { BILL_TYPE } from '@/utils/enum';

const VAT_TYPE = Object.freeze({ COMPANY: 1, INDIVIDUAL: 2 });
const RESULT_STATUS = Object.freeze({ SUCCESS: 'SUCCESS', FAILED: 'FAILED' });

export default {
  name: 'ReviewFastInvoiceModal',
  props: {
    // 'create' → Trang Hóa đơn (Tạo hóa đơn đỏ) · 'publish' → Trang Hóa đơn đỏ (Phát hành FAST)
    mode: {
      type: String,
      default: 'publish',
      validator: (value) => ['create', 'publish'].includes(value),
    },
  },
  data() {
    return {
      VAT_TYPE,
      RESULT_STATUS,
      // Loại hóa đơn nguồn (1=bán lẻ, 2=bán buôn) — quyết định mặc định B2B/B2C khi TẠO hóa đơn đỏ.
      billTypeContext: null,
      // billNumber của các HĐ đang mở rộng xem chi tiết sản phẩm.
      expandedRows: [],
      // Chế độ chỉnh sửa cho luồng PHÁT HÀNH (publish): false = chỉ xem, true = cho sửa KH trước khi đẩy.
      editMode: false,
      editModeOptions: [
        { value: false, text: 'Xem' },
        { value: true, text: 'Chỉnh sửa' },
      ],
      rows: [],
      loading: false,
      submitting: false,
      isSubmitted: false,
      fromPartner: 'FAST',
      fromPartnerOptions: [
        { value: 'MIFI', text: 'MIFI' },
        { value: 'FAST', text: 'FAST' },
      ],
      vatTypeOptions: [
        { value: VAT_TYPE.COMPANY, text: 'B2B' },
        { value: VAT_TYPE.INDIVIDUAL, text: 'B2C' },
      ],
    };
  },
  computed: {
    isCreateMode() {
      return this.mode === 'create';
    },
    modalTitle() {
      return this.isCreateMode
        ? 'Kiểm tra & Tạo hóa đơn đỏ'
        : 'Kiểm tra & Phát hành hóa đơn FAST';
    },
    confirmLabel() {
      return this.isCreateMode ? 'Tạo hóa đơn đỏ' : 'Phát hành';
    },
    successRowLabel() {
      return this.isCreateMode ? 'Đã tạo hóa đơn đỏ' : 'Đã phát hành';
    },
    defaultFailMessage() {
      return this.isCreateMode
        ? 'Tạo hóa đơn đỏ thất bại'
        : 'Phát hành hóa đơn thất bại';
    },
    validRows() {
      return this.rows.filter((row) => !row.isFatal);
    },
    fatalRows() {
      return this.rows.filter((row) => row.isFatal);
    },
    canSubmit() {
      return !this.submitting && !this.loading && this.pendingRows.length > 0;
    },
    successCount() {
      return this.rows.filter(
        (row) => row.resultStatus === RESULT_STATUS.SUCCESS,
      ).length;
    },
    failedCount() {
      return this.rows.filter(
        (row) => row.resultStatus === RESULT_STATUS.FAILED,
      ).length;
    },
    // Dòng còn cần xử lý: hợp lệ và CHƯA thành công (dùng cho submit + thử lại).
    pendingRows() {
      return this.rows.filter(
        (row) => !row.isFatal && row.resultStatus !== RESULT_STATUS.SUCCESS,
      );
    },
    hasResults() {
      return this.rows.some((row) => row.resultStatus);
    },
    // Số cột của bảng chính (dùng cho colspan dòng chi tiết sản phẩm).
    detailColspan() {
      return this.isCreateMode ? 11 : 9;
    },
    // Badge bán lẻ / bán buôn cạnh số HĐ (theo trang nguồn khi TẠO). Publish không có ngữ cảnh này → ẩn.
    billTypeBadge() {
      if (this.billTypeContext === BILL_TYPE.WHOLESALE_INVOICE) {
        return { text: 'Bán buôn', class: 'label-light-warning' };
      }
      if (this.billTypeContext === BILL_TYPE.RETAIL_INVOICE) {
        return { text: 'Bán lẻ', class: 'label-light-info' };
      }
      return null;
    },
  },
  methods: {
    isExpanded(billNumber) {
      return this.expandedRows.includes(billNumber);
    },
    toggleExpand(billNumber) {
      this.expandedRows = this.isExpanded(billNumber)
        ? this.expandedRows.filter((n) => n !== billNumber)
        : [...this.expandedRows, billNumber];
    },
    // Thuế suất 1 dòng SP: -1 = KCT (không chịu thuế), null = chưa có, còn lại 'X%'.
    detailVatLabel(detail) {
      const vat = Number(detail.vatAmount);
      if (detail.vatAmount == null || Number.isNaN(vat)) return '-';
      return vat === -1 ? 'KCT' : `${vat}%`;
    },
    // Chiết khấu 1 dòng SP = chiết khấu sản phẩm + chiết khấu phân bổ.
    detailDiscount(detail) {
      return (
        (Number(detail.discountAmount) || 0) +
        (Number(detail.allotmentDiscountAmount) || 0)
      );
    },
    // Đề xuất làm sạch (chưa áp) cho 1 field — null nếu không có.
    suggestionFor(row, field) {
      return (row.suggestions || []).find((s) => s.field === field) || null;
    },
    // Cảnh báo (không chặn) cho 1 field.
    warningsFor(row, field) {
      return (row.warnings || []).filter((w) => w.field === field);
    },
    // User bấm "Áp dụng" → ghi giá trị đề xuất vào bản làm việc + gỡ đề xuất đó khỏi danh sách.
    applySuggestion(row, suggestion) {
      if (!suggestion) return;
      row.form[suggestion.field] = suggestion.to;
      row.suggestions = row.suggestions.filter((s) => s !== suggestion);
    },
    isEditable(row) {
      // Khóa dòng đã tạo/phát hành THÀNH CÔNG; dòng FATAL (lỗi validate) không sửa ở đây.
      // Dòng chưa xử lý hoặc xử lý THẤT BẠI → vẫn cho sửa để thử lại.
      return row.resultStatus !== RESULT_STATUS.SUCCESS && !row.isFatal;
    },
    // Tổng thành tiền / chiết khấu / thuế suất VAT của 1 hóa đơn (tính từ details).
    rowTotalAmount(row) {
      return (row.details || []).reduce(
        (sum, d) => sum + (Number(d.totalAmount) || 0),
        0,
      );
    },
    rowDiscountAmount(row) {
      return (row.details || []).reduce(
        (sum, d) =>
          sum +
          (Number(d.discountAmount) || 0) +
          (Number(d.allotmentDiscountAmount) || 0),
        0,
      );
    },
    rowVatRates(row) {
      const rates = [
        ...new Set((row.details || []).map((d) => Number(d.vatAmount))),
      ].filter((r) => !Number.isNaN(r));
      if (!rates.length) return '-';
      return rates.map((r) => (r === -1 ? 'KCT' : `${r}%`)).join(', ');
    },
    formatMoney(value) {
      return convertPrice(Number(value) || 0);
    },
    // Trả về hàm debounce riêng cho từng dòng (theo billNumber) để tra MST
    // của dòng này không đè lên dòng khác khi người dùng sửa nhiều dòng.
    getTaxDebouncer(row) {
      if (!this.taxDebouncers) this.taxDebouncers = {};
      const key = row.billNumber;
      if (!this.taxDebouncers[key]) {
        this.taxDebouncers[key] = debounce((query) => {
          this.fetchTaxCode(query, row);
        }, TIME_TRIGGER);
      }
      return this.taxDebouncers[key];
    },
    onTaxCodeInput(row, value) {
      // Chỉ tra cứu MST cho dòng B2B đang được phép sửa.
      if (!this.isEditable(row) || row.billVatType !== VAT_TYPE.COMPANY) return;
      const raw = value != null ? String(value).trim() : '';
      if (!raw) return;
      const query = xoa_dau(raw);
      this.getTaxDebouncer(row)(query);
    },
    async fetchTaxCode(query, row) {
      if (!query) return;
      try {
        const response = await ApiService.query('vat-bills/tax-search', {
          params: { taxCode: query, fromPartner: this.fromPartner },
        });
        const data = response.data && response.data.data;
        if (!data) {
          makeToastFaile(`Không tìm thấy thông tin MST cho HĐ ${row.billNumber}`);
          return;
        }
        // Auto-fill đúng dòng đang sửa. Các key đã được khởi tạo trong
        // transformValidateItem nên gán trực tiếp vẫn giữ reactivity.
        if (data.vatName) row.form.billVatName = data.vatName;
        if (data.vatAddress) row.form.billVatAddress = data.vatAddress;
        if (data.taxCode) row.form.taxCode = data.taxCode;
        makeToastSuccess(
          response.data.message ||
            `Đã cập nhật thông tin MST cho HĐ ${row.billNumber}`,
        );
      } catch (error) {
        makeToastFaile(
          error.response?.data?.message ||
            `Không tìm thấy thông tin MST cho HĐ ${row.billNumber}`,
        );
      }
    },
    // Bấm icon cạnh input MST → tra cứu & điền ngay (không đợi debounce).
    lookupTaxCode(row) {
      if (!this.isEditable(row) || row.billVatType !== VAT_TYPE.COMPANY) return;
      const raw =
        row.form.taxCode != null
          ? String(row.form.taxCode).trim()
          : '';
      if (!raw) {
        makeToastFaile('Vui lòng nhập MST để tra cứu.');
        return;
      }
      this.fetchTaxCode(xoa_dau(raw), row);
    },
    open(billIds, billType = null) {
      this.rows = [];
      this.isSubmitted = false;
      this.submitting = false;
      this.taxDebouncers = {};
      this.expandedRows = [];
      this.editMode = false;
      // Lưu TRƯỚC khi validate vì transformValidateItem dùng để set mặc định B2B/B2C.
      this.billTypeContext = billType;
      this.$refs['review-fast-invoice-modal'].show();
      this.validate(billIds);
    },
    hide() {
      this.$refs['review-fast-invoice-modal'].hide();
    },
    onHidden() {
      this.rows = [];
      this.isSubmitted = false;
      this.submitting = false;
      this.taxDebouncers = {};
      this.billTypeContext = null;
      this.expandedRows = [];
      this.editMode = false;
    },
    async validate(billIds) {
      if (!Array.isArray(billIds) || !billIds.length) {
        makeToastFaile('Vui lòng chọn ít nhất một đơn hàng để kiểm tra');
        return;
      }
      this.loading = true;
      try {
        const res = await ApiService.post('vat-bills/fast-invoices/validate', {
          billIds,
          mode: this.mode,
        });
        const { status, message, data } = res.data;
        if (status !== 1) {
          makeToastFaile(message || 'Kiểm tra hóa đơn thất bại');
          return;
        }
        this.rows = (data || []).map((item) => this.transformValidateItem(item));
      } catch (error) {
        makeToastFaile(
          error.response?.data?.message ||
            'Có lỗi xảy ra khi kiểm tra hóa đơn. Vui lòng thử lại.',
        );
      } finally {
        this.loading = false;
      }
    },
    transformValidateItem(item) {
      const original = item.originalData || {};
      let billVatType = original.billVatType || VAT_TYPE.COMPANY;
      // Khi TẠO hóa đơn đỏ: bán buôn (wholesale) mặc định B2B; bán lẻ giữ mặc định theo BE
      // (taxCode ? B2B : B2C). Không áp cho luồng phát hành (publish) vì loại đã cố định trên HĐĐ.
      if (
        this.isCreateMode &&
        this.billTypeContext === BILL_TYPE.WHOLESALE_INVOICE
      ) {
        billVatType = VAT_TYPE.COMPANY;
      }
      // Dòng có giá trị > 0đ mặc định XUẤT; dòng 0đ (quà tặng) mặc định KHÔNG xuất — user tự bật.
      const details = (Array.isArray(item.details) ? item.details : []).map(
        (d) => ({ ...d, include: !d.isZeroValue }),
      );
      return {
        billId: item.billId,
        billNumber: item.billNumber,
        billVatType,
        // `form` = bản làm việc, khởi tạo từ dữ liệu GỐC (KHÔNG auto-clean). User tự sửa / bấm áp dụng đề xuất.
        form: {
          billVatName: original.billVatName || '',
          taxCode: original.taxCode || '',
          billVatAddress: original.billVatAddress || '',
          email: original.email || '',
          phone: original.phone || '',
        },
        suggestions: Array.isArray(item.suggestions) ? item.suggestions : [],
        warnings: Array.isArray(item.warnings) ? item.warnings : [],
        details,
        errors: Array.isArray(item.errors) ? item.errors : [],
        isFatal: Boolean(item.isFatal),
        resultStatus: null,
        billVatId: null,
        fastInvoiceNo: null,
        fastSyncStatusId: null,
        error: null,
      };
    },
    async onSubmitBatch() {
      if (!this.canSubmit) return;
      this.submitting = true;
      const invoices = this.pendingRows.map((row) => ({
        billId: row.billId,
        billNumber: row.billNumber,
        sanitizedData: {
          ...row.form,
          billVatType: row.billVatType,
        },
        // Chỉ luồng PHÁT HÀNH: khi user bật "Chỉnh sửa" → BE cập nhật lại thông tin KH trước khi đẩy FAST.
        edited: !this.isCreateMode && this.editMode,
        // Dòng user chọn xuất (theo billItemId) — BE tạo HĐ đúng các dòng này (gồm cả 0đ nếu bật).
        includedBillItemIds: row.details
          .filter((d) => d.include)
          .map((d) => d.billItemId)
          .filter((id) => id != null),
      }));
      try {
        let res;
        if (this.isCreateMode) {
          res = await ApiService.post('vat-bills/fast-invoices/create-batch', {
            invoices,
          });
        } else {
          const idempotenceKey = uuidv4();
          res = await ApiService.post(
            'vat-bills/fast-invoices/issue-batch',
            { invoices },
            idempotenceKey,
          );
        }
        const { status, message, data } = res.data;
        if (status !== 1) {
          makeToastFaile(message || this.defaultFailMessage);
          return;
        }
        const results = data || [];
        this.applyResult(results);
        this.isSubmitted = true;
        this.notifyBatchResult(results);
        this.$emit('submitted');
      } catch (error) {
        makeToastFaile(
          error.response?.data?.message ||
            'Có lỗi xảy ra khi xử lý. Vui lòng thử lại.',
        );
      } finally {
        this.submitting = false;
      }
    },
    applyResult(results) {
      const resultMap = {};
      results.forEach((result) => {
        resultMap[result.billNumber] = result;
      });
      this.rows.forEach((row) => {
        const result = resultMap[row.billNumber];
        if (!result) return;
        row.resultStatus = result.status;
        row.billVatId = result.billVatId || null;
        row.fastInvoiceNo = result.fastInvoiceNo || null;
        row.fastSyncStatusId = result.fastSyncStatusId || null;
        row.error = result.error || null;
      });
    },
    // Thông báo tóm tắt theo KẾT QUẢ thực tế: tất cả OK / một phần lỗi / lỗi toàn bộ.
    notifyBatchResult(results) {
      const total = results.length;
      if (!total) return;
      const success = results.filter((r) => r.status === 'SUCCESS').length;
      const failed = total - success;
      const action = this.confirmLabel; // 'Tạo hóa đơn đỏ' | 'Phát hành'

      if (failed === 0) {
        makeToastSuccess(`${action} thành công ${success}/${total} hóa đơn.`);
      } else if (success === 0) {
        makeToastFaile(
          `${action} thất bại toàn bộ ${failed}/${total} hóa đơn. Vui lòng kiểm tra các dòng lỗi.`,
        );
      } else {
        makeToastWarning(
          `${action}: thành công ${success} hóa đơn, ${failed} hóa đơn thất bại. Vui lòng kiểm tra các dòng lỗi.`,
        );
      }
    },
    // Sau khi tạo hóa đơn đỏ thành công → điều hướng sang trang danh sách hóa đơn đỏ.
    goToVatInvoiceList() {
      this.hide();
      if (this.$route && this.$route.name === 'vat-invoice-v2') return;
      this.$router.push({ name: 'vat-invoice-v2' }).catch(() => {});
    },
  },
};
</script>

<style scoped>
/* Cho phép bảng tràn ngang + cuộn khi tổng min-width các cột lớn hơn bề rộng modal. */
.table-responsive {
  overflow-x: auto;
}

.review-fast-table {
  width: 100%;
}

.review-fast-table th {
  background-color: #f3f6f9;
  font-size: 0.85rem;
  vertical-align: middle;
  white-space: nowrap;
}

.review-fast-table td {
  vertical-align: middle;
}

/* Dòng có lỗi (isFatal) — tô nền đỏ nhạt từng ô để nổi rõ, không chỉ hiện message. */
.review-fast-table tr.review-fast-error-row > td {
  background-color: #ffd5d9 !important;
}

.review-fast-expand-btn {
  font-size: 0.78rem;
  font-weight: 600;
  text-decoration: none;
}

/* Dòng chi tiết sản phẩm mở rộng dưới mỗi hóa đơn. */
.review-fast-detail-row > td {
  background-color: #f9fafc;
}

.review-fast-detail-table {
  background-color: #fff;
  font-size: 0.8rem;
}

.review-fast-detail-table th {
  background-color: #eef1f5;
  white-space: nowrap;
}

.review-fast-suggest {
  line-height: 1.3;
}

.review-fast-apply {
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
}
</style>
